import { render, staticRenderFns } from "./BecomeACreatorSection.vue?vue&type=template&id=eb47d5a8"
import script from "./BecomeACreatorSection.vue?vue&type=script&lang=js"
export * from "./BecomeACreatorSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports